"use client";
import { createContext, useContext, useEffect, useState } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { STORAGE_KEY_UTM_PARAMS } from "../utils/constants/storageKeys";
import { UTM_PARAMS } from "@/projectRoot/api-client/interfaces/utils/global-enums";
import { bodyDisableScroll } from "../utils/handlers/miscHandler";
import Toaster, { Toast } from "../components/common/general/toaster/Toaster";

export interface GlobalsContextProps {
    utmParams?: Record<UTM_PARAMS, string>;
    setUtmParams?: React.Dispatch<React.SetStateAction<Record<UTM_PARAMS, string>>> | any;
    isMobileView: boolean;
    toasts: Toast[];
    setToasts: React.Dispatch<React.SetStateAction<Toast[]>>;
}

export const defaultGlobals : GlobalsContextProps = {
    utmParams: undefined,
    setUtmParams: (utmParams?: React.SetStateAction<Record<UTM_PARAMS, string> | undefined>) => utmParams,
    isMobileView: true,
    toasts: [],
    setToasts: (toasts: Toast[]) => toasts
}

export const GlobalsContext = createContext<GlobalsContextProps>(defaultGlobals)

export type Props = Partial<GlobalsContextProps> & {
    children?: any
}

export function GlobalsProvider({
    children
}: Partial<Props>) {

    const [isMobileView, setIsMobileView] = useState<boolean>(true);
    // const router = useRouter()
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const [utmParams, setUtmParams] = useState<Record<string, string>>();
    const [toasts, setToasts] = useState<Toast[]>([]);

    const handleResize = () => {
        setIsMobileView(window.innerWidth < 992);
    };

    useEffect(() => {
        if(typeof window !== 'undefined'){
            bodyDisableScroll(false);
            handleResize();
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            }
        }
    }, [pathname]);

    useEffect(() => {
        let params: Record<string, string> = {};
        for(const [key, value] of searchParams.entries()){
            if(Object.values(UTM_PARAMS).includes(key as UTM_PARAMS) && value){
                params[key] = value as string;
            }
        }
        if(Object.keys(params).length > 0 && typeof window !== 'undefined'){
            params[UTM_PARAMS['FULL_SLUG_WITH_PARAMS']] = decodeURIComponent(encodeURIComponent(window.location.href));
            sessionStorage.setItem(STORAGE_KEY_UTM_PARAMS, JSON.stringify(params));
        }
        // writeStorage(STORAGE_KEY_UTM_PARAMS, JSON.stringify(params));
    }, []);

    useEffect(() => {
        let params = sessionStorage.getItem(STORAGE_KEY_UTM_PARAMS);
        setUtmParams(params ? JSON.parse(params) : undefined);
    }, []);


    // fix for now
    useEffect(() => {
        if(pathname.includes('home_')){
            let timeout = setTimeout(() => {
                window.location.href = '/home';
            }, 0);
        }
    }, []);

    return (
        <GlobalsContext.Provider value={{ 
            utmParams,
            setUtmParams,
            isMobileView,
            toasts,
            setToasts,
             }}>
            <Toaster />
            {children}
        </GlobalsContext.Provider>
    )
}

//context hooks
export function useGlobals(): GlobalsContextProps {
    return useContext<GlobalsContextProps>(GlobalsContext);
}